export default __webpack_public_path__ + "static/media/HelveticaNeueLT-Light.45662bcc.eot";